import React from 'react';
import { MapPin, Facebook, Instagram, Twitter, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-blue-900 to-blue-950 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">{companyInfo.name}</h3>
            <p className="text-blue-200 mb-4 leading-relaxed">
              Expertos en reparación de electrodomésticos con más de 15 años de experiencia. 
              Tu satisfacción es nuestra prioridad.
            </p>
            <div className="flex gap-3">
              <div 
                className="bg-blue-800 hover:bg-blue-700 p-2 rounded-lg transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </div>
              <div 
                className="bg-blue-800 hover:bg-blue-700 p-2 rounded-lg transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </div>
              <div 
                className="bg-blue-800 hover:bg-blue-700 p-2 rounded-lg transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('inicio')}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('servicios')}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('nosotros')}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Nosotros
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('testimonios')}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Testimonios
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contacto')}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Servicios</h4>
            <ul className="space-y-2 text-blue-200">
              <li>Reparación de Neveras</li>
              <li>Reparación de Lavadoras</li>
              <li>Reparación de Secadoras</li>
              <li>Reparación de Microondas</li>
              <li>Mantenimiento General</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <div>
                  <a 
                    href={`https://wa.me/${companyInfo.whatsapp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-200 hover:text-white transition-colors"
                  >
                    {companyInfo.phone}
                  </a>
                  <div className="text-sm text-blue-300">WhatsApp</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="text-blue-200 hover:text-white transition-colors break-all"
                >
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <div className="text-blue-200">{companyInfo.address}</div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-blue-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-blue-300 text-sm">
              © {currentYear} {companyInfo.name}. Todos los derechos reservados.
            </p>
            <div className="flex gap-6 text-sm text-blue-300">
              <span className="cursor-default">
                Política de Privacidad
              </span>
              <span className="cursor-default">
                Términos de Servicio
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
